import './loaderNew.css'

const LoaderNew = () => {
  return <div className='loaderer'></div>
}

export default LoaderNew
